<template>
    <div>
        <day-configurator-body :initial-step="'planning'"></day-configurator-body>
    </div>
</template>

<script>
export default {
    name: 'day-configurator-show',
}
</script>